<template>
    <div class="gallery-card block-card card-border ">
        <v-expansion-panel expand :value="panel">
            <v-expansion-panel-content :lazy="true">
                <template v-slot:header >
                    <div class="block-card-title handle" >
                        <div class="title-icon">
                            <img src="../../../../assets/img/ic_gallery-sm.png" alt="">
                        </div>

                        <h4>Gallery</h4>
                    </div>
                </template>
                <div class="block-card-body">
                    <v-layout row wrap>
                        <v-flex xs6 v-for="(item, index) in data.items" class="mt-5">
                            <div class="gallery-item delete-wrapper" >
                                <image-input :url="item.url" @onImageUpload="item.url = $event"></image-input>
                                <label class="mt-3 d-inline-block">Image Url</label>
<!--                                <v-text-field-->
<!--                                        v-model="item.url"-->
<!--                                        :error="!item.url"-->
<!--                                        :error-messages="!item.url? 'URL is Required':''"-->
<!--                                        outline-->
<!--                                >-->
<!--                                </v-text-field>-->
                                <vTextareaAutocomplete v-model="item.url" :type="'textfield'"
                                                       :validationRules="autocompleteGalleryUrlValidationRules"></vTextareaAutocomplete>
                                <label class="mt-3 d-inline-block">Title</label>
<!--                                <v-text-field-->
<!--                                        v-model="item.header"-->
<!--                                        :error="!item.header"-->
<!--                                        :error-messages="!item.header? 'Title is Required':''"-->
<!--                                        outline-->
<!--                                >-->
<!--                                </v-text-field>-->
                                <vTextareaAutocomplete v-model="item.header" :type="'textfield'"
                                                       :validationRules="autocompleteGalleryHeaderValidationRules"></vTextareaAutocomplete>
                                <buttons-list :buttons="item.buttons" :blocks-list="blocksList" ></buttons-list>
                                <v-btn class="delete-button" @click="deleteGalleryItem(index)" fab small color=""><v-icon small color="#666">delete_outline</v-icon></v-btn>
                            </div>
                        </v-flex>
                        <v-flex xs6 class="mt-5">
                            <div class="gallery-item add-gallery-item" >
                                <v-btn
                                        large round flat block
                                        class="primary--text"
                                        @click="addGalleryItem"
                                >
                                    <v-icon>add_circle_outline</v-icon>
                                    Add Gallery Item
                                </v-btn>
                            </div>
                        </v-flex>
                    </v-layout>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </div>
</template>

<script>
    import common from "../../../../utils/common"
    import imageInput from './common-inner-blocks/image-uploader-dropzone'
    import buttonsList from './common-inner-blocks/button-list'
    export default {
        name: "card-image-url",
        components: {
            imageInput,
            buttonsList
        },
        props: {
            data: {
                type: Object,
                default: ()=> {
                    return {}
                }
            },
            index: {
                type: Number,
                default: ()=> {
                    return 0
                }
            },
            blocksList: {
                type: Array,
                default: ()=> {
                    return []
                }
            }
        },
        data() {
            return {
                valid: true,
                panel: 1,
                common,
                autocompleteGalleryUrlValidationRules: [
                    v => !!v || 'URL is Required'
                ],
                autocompleteGalleryHeaderValidationRules: [
                    v => !!v || 'Title is Required'
                ]
            }
        },
        mounted() {

        },
        methods: {
            addGalleryItem() {
                this.data.items.push({
                    url:'',
                    header:'',
                    subtitle:'',
                    imageUrl:'',
                    buttons:[]
                })
            },
            deleteGalleryItem(index) {
                this.data.items.splice(index, 1)
            }
        },
        computed: {

        },
        watch: {

        }
    }
</script>

<style scoped>

</style>